
export enum OrganizationEventType {
    ORGANIZATION_CREATED = "organization.organizationCreated",
    ORGANIZATION_UPDATED = "organization.organizationUpdated",
    ORGANIZATION_DELETED = "organization.organizationDeleted",
}